import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Bassem Ammar </span>
            from <span className="purple"> Tunisia</span>
            <br />
            a Full-Stack JavaScript Developer currently working at Ostrix.
            <br />
            With expertise in React.js, React Native, Node.js, Express.js, MongoDB, and MySQL, I specialize in building scalable and user-friendly web and mobile applications.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Camping
            </li>
            <li className="about-activity">
              <ImPointRight /> Volunteer in the Red Crescent
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Bassem Ammar</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
